import { TranslationKey } from '@Localization';
import { AnnotationStatus } from '../../__legacy__/modules/annotation/annotations.interface';
import { ImageAnnotationStatus } from '../../__legacy__/modules/projectDetails/sub/images/projectDetailsImages.model';

export const getAnnotationStatusText = (annotationStatus: AnnotationStatus | ImageAnnotationStatus): TranslationKey | '' => {
  switch (annotationStatus) {
    case AnnotationStatus.DRAFT:
    case ImageAnnotationStatus.DRAFT:
      return 'image_annotation_status.draft';
    case AnnotationStatus.REJECTED:
    case ImageAnnotationStatus.REJECTED:
      return 'image_annotation_status.rejected';
    case AnnotationStatus.TOREVIEW:
    case ImageAnnotationStatus.TOREVIEW:
      return 'image_annotation_status.to_review';
    case AnnotationStatus.ACCEPTED:
    case ImageAnnotationStatus.ACCEPTED:
      return 'image_annotation_status.accepted';
    case AnnotationStatus.DISCARDED:
    case ImageAnnotationStatus.DISCARDED:
      return 'image_annotation_status.discarded';
    case ImageAnnotationStatus.CLARIFICATION:
      return 'image_annotation_status.clarification';
    case AnnotationStatus.NONE:
    case ImageAnnotationStatus.NONE:
      return 'image_annotation_status.none';
    default:
      return '';
  }
};
